import {
  Box,
  Container,
  TextField,
  Button,
  CircularProgress,
  Typography,
} from "@mui/material";
import React from "react";
import BackBtn from "../../../widgets/BackBtn";
import PageTitle from "../../../widgets/PageTitle";
import { useForm } from "react-hook-form";
import SaveIcon from "@mui/icons-material/Save";
import { getHeader, toastError } from "../../../utils/util";
import axios from "axios";
import { API_ENDPOINT } from "../../../utils/constants";
import { toast } from "react-toastify";
import { GlassButton } from "../../../themes/UiElements";
const AddChatbotFlow = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm();

  const onSubmit = async (data) => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT}/message/add-chatbot-flow`,
        data,
        getHeader()
      );
      toast.success(response.data.message);
      reset();
    } catch (error) {
      toastError(error);
    }
  };
  const validPattern = /^[a-zA-Z0-9 _,-]+$/;
  return (
    <Container maxWidth="md" sx={{ mt: 3 }}>
      <BackBtn />
      <Container maxWidth="sm" sx={{ my: 2 }}>
        <PageTitle mb={2}>Add Chatbot Flow</PageTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box sx={{ mb: 3 }}>
            <TextField
              fullWidth
              label="Flow Name"
              variant="outlined"
              disabled={isSubmitting}
              {...register("flowName", {
                required: "Flow name is required",
                maxLength: {
                  value: 100,
                  message: "Maximum length is 100 characters",
                },
                pattern: {
                  value: validPattern,
                  message:
                    "Only alphabets, numbers, space, underscore and dash are allowed",
                },
              })}
              error={!!errors.flowName}
              helperText={errors.flowName?.message}
            />
          </Box>

          <Box sx={{ mb: 3 }}>
            <TextField
              fullWidth
              label="Flow Starter"
              variant="outlined"
              disabled={isSubmitting}
              {...register("flowStarter", {
                required: "Flow starter is required",
                maxLength: {
                  value: 100,
                  message: "Maximum length is 100 characters",
                },
                pattern: {
                  value: validPattern,
                  message:
                    "Only alphabets, numbers, space, underscore, commas and dash are allowed",
                },
              })}
              error={!!errors.flowStarter}
              helperText={errors.flowStarter?.message}
            />
            <Typography variant="caption">
              This starter can be template button or incoming message. eg.
              hi/STOP
            </Typography>
          </Box>

          <Box display={"flex"} justifyContent={"end"}>
            <GlassButton
              type="submit"
              variant="contained"
              color="primary"
              size="large"
              disabled={isSubmitting}
              startIcon={
                isSubmitting ? <CircularProgress size={20} /> : <SaveIcon />
              }
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </GlassButton>
          </Box>
        </form>
      </Container>
    </Container>
  );
};

export default AddChatbotFlow;
